import React, { useEffect, useState } from 'react';
import { FaTimes, FaChevronRight } from 'react-icons/fa';
import axios from '../../api/axios';

interface Pharmacy {
  outlet_id: string;
  outlet: string;
}

interface PharmacyModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPharmacySelect: (pharmacy: Pharmacy) => void;
  onSave: (alamatBaru: string) => void;
  alamatBaru: string;
  prescription_id?: number;
}

const PharmacyModal: React.FC<PharmacyModalProps> = ({
  isOpen,
  onClose,
  onPharmacySelect,
  onSave,
  alamatBaru,
  prescription_id,
}) => {
  const [pharmaciesData, setPharmaciesData] = useState<Pharmacy[]>([]);
  const [isLoading, setIsLoading] = useState(false); // ✅ State loading

  const storedData = sessionStorage.getItem('userData');
  const userDataDefault = storedData ? JSON.parse(storedData) : {};
  const userData = userDataDefault;
  const token = userData?.token || '';

  useEffect(() => {
    const fetchAddress = async () => {
      try {
        setIsLoading(true); // ✅ Mulai loading
        const response = await axios.post(
          `prescriptions/check-stock/${prescription_id}`,
          {
            address_id:
              userData?.person?.address?.[userData.person.address.length - 1]?.id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = response.data.data;
        setPharmaciesData(data.outlets || []);
      } catch (error) {
        console.error('Error fetching pharmacy data:', error);
      } finally {
        setIsLoading(false); // ✅ Selesai loading
      }
    };

    if (isOpen && prescription_id) {
      fetchAddress();
    }
  }, [isOpen, prescription_id]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100">
      <div className="bg-white rounded-xl p-5 w-full max-w-sm shadow-lg relative">
        <button className="absolute top-2 right-2 text-gray-600" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="text-center mb-4">
          <div className="w-10 h-1 bg-gray-300 rounded-full mx-auto mb-2" />
          <h3 className="text-lg font-semibold text-teal-600">Pilih Apotek</h3>
        </div>

        <div className="space-y-3">
          {alamatBaru ? (
            isLoading ? (
              <p className="text-sm text-gray-600 text-center">Mohon menunggu...</p>
            ) : pharmaciesData.length > 0 ? (
              pharmaciesData.map((pharmacy) => (
                <button
                  key={pharmacy.outlet_id}
                  className="w-full flex justify-between items-center p-3 bg-gray-100 rounded-lg hover:bg-gray-200 text-left text-sm font-medium"
                  onClick={() => {
                    onPharmacySelect(pharmacy);
                    onClose();
                  }}
                >
                  {pharmacy.outlet}
                  <FaChevronRight className="text-gray-400" />
                </button>
              ))
            ) : (
              <p className="text-sm text-gray-600">
                Tidak ada apotek yang tersedia. Silakan tebus Offline.
              </p>
            )
          ) : (
            <div className="text-center">
              <p className="text-sm text-gray-600">
                Silakan isi alamat terlebih dahulu untuk melihat opsi apotek.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PharmacyModal;
